/**
 * Moves Lipscore review summary attrs element after the buy buttons block
 * Handles cases where the element may not be rendered on page load
 */
(function() {
  'use strict';

  const REVIEW_ATTRS_SELECTOR = '.lipscore-review-summary-attrs';
  const TARGET_SELECTOR = '.product__block.product__block--buy_buttons';
  const MAX_WAIT_TIME = 10000; // 10 seconds max wait time
  const CHECK_INTERVAL = 500; // Check every 500ms

  let hasMoved = false; // Track if we've already moved the element
  let observer = null;
  let checkInterval = null;
  let timeoutId = null;

  /**
   * Moves the review attrs element after the buy buttons block
   * @returns {boolean} True if move was successful, false otherwise
   */
  function moveReviewAttrs() {
    // Don't move if we've already done it
    if (hasMoved) {
      return true;
    }

    const reviewAttrs = document.querySelector(REVIEW_ATTRS_SELECTOR);
    const targetBlock = document.querySelector(TARGET_SELECTOR);

    // Both elements must exist to move
    if (!reviewAttrs || !targetBlock) {
      return false;
    }

    // Check if already in the correct position (to avoid unnecessary DOM manipulation)
    if (targetBlock.nextElementSibling === reviewAttrs) {
      hasMoved = true;
      return true;
    }

    // Move the element after the target block
    try {
      targetBlock.insertAdjacentElement('afterend', reviewAttrs);
      hasMoved = true;
      return true;
    } catch (error) {
      console.warn('Failed to move Lipscore review attrs:', error);
      return false;
    }
  }

  /**
   * Clean up observers and intervals
   */
  function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }

  /**
   * Initialize using MutationObserver and polling
   */
  function init() {
    // Try immediately in case elements are already present
    if (moveReviewAttrs()) {
      return;
    }

    // Set up MutationObserver to watch for dynamically added elements
    observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;

      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if the added node is or contains our target elements
              if (
                (node.matches && (node.matches(REVIEW_ATTRS_SELECTOR) || node.matches(TARGET_SELECTOR))) ||
                (node.querySelector && (node.querySelector(REVIEW_ATTRS_SELECTOR) || node.querySelector(TARGET_SELECTOR)))
              ) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      if (shouldCheck && !hasMoved) {
        if (moveReviewAttrs()) {
          cleanup();
        }
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check periodically as a fallback
    checkInterval = setInterval(function() {
      if (!hasMoved && moveReviewAttrs()) {
        cleanup();
      }
    }, CHECK_INTERVAL);

    // Stop checking after max wait time
    timeoutId = setTimeout(function() {
      cleanup();
      if (!hasMoved) {
        console.warn('Lipscore review attrs element not found after waiting period');
      }
    }, MAX_WAIT_TIME);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM is already ready
    init();
  }
})();

